export default __webpack_public_path__ + "static/media/about5bg1.5540eb82.png";